import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

// Shows only the settings that apply to the chosen field type in the builder's field modal.
// Each section lists its types in data-types="select checkboxes". The "show when" picker
// enables only the chosen parent's choices, so nothing else posts.
// Choices reorder in the page only; the form posts them in DOM order and that order is saved.
// A new field's per-guest switch follows the type (on for a dropdown, off for checkboxes) until staff set it.
export default class extends Controller {
  static targets = ['type', 'section', 'parent', 'parentValues', 'choices', 'perGuest']

  connect() {
    this.toggle()
    this.toggleParent()
    if (this.hasChoicesTarget) {
      this.sortable = Sortable.create(this.choicesTarget, { handle: '.handle', animation: 150 })
    }
  }

  disconnect() {
    this.sortable?.destroy()
  }

  // A quick-add button opens the new-field modal carrying data-field-type; start on that type.
  preset(event) {
    const type = event.relatedTarget?.dataset.fieldType
    if (!type || !event.target.contains(this.element)) return

    this.typeTarget.value = type
    this.toggle()
  }

  toggle() {
    const type = this.typeTarget.value
    if (this.hasPerGuestTarget && !this.perGuestSet) this.perGuestTarget.checked = type === 'select'
    this.sectionTargets.forEach((section) => {
      section.classList.toggle('d-none', !section.dataset.types.split(' ').includes(type))
    })
  }

  holdPerGuest() {
    this.perGuestSet = true
  }

  toggleParent() {
    if (!this.hasParentTarget) return
    const key = this.parentTarget.value
    this.parentValuesTargets.forEach((group) => {
      const active = group.dataset.parent === key
      group.classList.toggle('d-none', !active)
      group.querySelectorAll('input').forEach((input) => { input.disabled = !active })
    })
  }
}
